/**
 * MproProductGallery - 产品图片/视频画廊
 * media数据由Mpro.liquid页面传入
 */
var MproProductGallery = {
  currentIndex: 0,
  isPlaying: false,
  touchStartX: null,
  touchEndX: null,
  ifFirstFlag: true,
  media: [],

  init: function () {
    var self = this;

    // Navigation buttons
    var prevBtn = document.getElementById('galleryPrev');
    var nextBtn = document.getElementById('galleryNext');
    if (prevBtn) prevBtn.addEventListener('click', function () { self.prev(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { self.next(); });

    // Gallery main area touch events
    var main = document.getElementById('galleryMain');
    if (main) {
      main.addEventListener('touchstart', function (e) { self.handleTouchStart(e); }, { passive: true });
      main.addEventListener('touchmove', function (e) { self.handleTouchMove(e); }, { passive: true });
      main.addEventListener('touchend', function () { self.handleTouchEnd(); });
    }

    // Video events
    var videoEl = document.getElementById('galleryVideoEl');
    if (videoEl) {
      videoEl.addEventListener('play', function () { self.isPlaying = true; self.updatePlayPauseIcon(); });
      videoEl.addEventListener('pause', function () { self.isPlaying = false; self.updatePlayPauseIcon(); });
      videoEl.addEventListener('timeupdate', function () { self.handleTimeUpdate(); });
    }

    // Play overlay click
    var overlay = document.getElementById('galleryPlayOverlay');
    if (overlay) overlay.addEventListener('click', function () { self.togglePlay(); });

    // Play/Pause button
    var ppBtn = document.getElementById('galleryPlayPauseBtn');
    if (ppBtn) ppBtn.addEventListener('click', function (e) { e.stopPropagation(); self.togglePlay(); });

    // Progress bar seek
    var progressBar = document.getElementById('galleryProgressBar');
    if (progressBar) {
      progressBar.addEventListener('click', function (e) { self.handleSeek(e); });
    }

    // Initial render
    this.render(0);
  },

  setIndex: function (idx) {
    this.render(idx);
  },

  next: function () {
    this.render((this.currentIndex + 1) % this.media.length);
  },

  prev: function () {
    this.render((this.currentIndex - 1 + this.media.length) % this.media.length);
  },

  render: function (idx) {
    this.currentIndex = idx;
    var item = this.media[idx];

    // Reset video state when switching away
    if (item.type === 'video') {
      var videoEl = document.getElementById('galleryVideoEl');
      var videoContainer = document.getElementById('galleryVideo');
      var imageEl = document.getElementById('galleryImage');
      var overlay = document.getElementById('galleryPlayOverlay');

      if (videoContainer) videoContainer.classList.remove('hidden');
      if (imageEl) imageEl.classList.add('hidden');
      if (videoEl) {
        videoEl.src = item.src;
        videoEl.load();
        videoEl.muted = false;
      }
      this.isPlaying = false;
      if (overlay) overlay.classList.remove('hidden');
      this.updatePlayPauseIcon();
      document.getElementById('galleryProgressFill').style.width = '0%';
    } else {
      var videoContainer2 = document.getElementById('galleryVideo');
      var imageEl2 = document.getElementById('galleryImage');

      if (videoContainer2) videoContainer2.classList.add('hidden');
      if (imageEl2) {
        imageEl2.classList.remove('hidden');
        imageEl2.src = item.src;
      }
      this.isPlaying = false;
    }

    this.updateThumbnails();
  },

  updateThumbnails: function () {
    var thumbs = document.querySelectorAll('.gallery-thumb');
    var self = this;
    thumbs.forEach(function (thumb) {
      var index = parseInt(thumb.getAttribute('data-index'));
      if(index==0&&self.ifFirstFlag){
        thumb.classList.add('border-transparent');
        thumb.classList.remove('border-[rgb(136,72,249)]');
        self.ifFirstFlag = false;
      }
      if (index === MproProductGallery.currentIndex) {
        thumb.classList.add('active');
      } else {
        thumb.classList.remove('active');
      }
    });
  },

  togglePlay: function () {
    var videoEl = document.getElementById('galleryVideoEl');
    var overlay = document.getElementById('galleryPlayOverlay');
    if (!videoEl) return;

    if (this.isPlaying) {
      videoEl.pause();
      if (overlay) overlay.classList.remove('hidden');
    } else {
      var promise = videoEl.play();
      if (promise && promise.catch) {
        promise.catch(function () {
          MproProductGallery.isPlaying = false;
          MproProductGallery.updatePlayPauseIcon();
        });
      }
      if (overlay) overlay.classList.add('hidden');
    }
  },

  updatePlayPauseIcon: function () {
    var icon = document.getElementById('galleryPlayPauseIcon');
    if (!icon) return;
    if (this.isPlaying) {
      icon.setAttribute('data-lucide', 'pause');
    } else {
      icon.setAttribute('data-lucide', 'play');
    }
    if (typeof lucide !== 'undefined') lucide.createIcons();
  },

  handleTimeUpdate: function () {
    var videoEl = document.getElementById('galleryVideoEl');
    if (!videoEl || !videoEl.duration) return;
    var progress = (videoEl.currentTime / videoEl.duration) * 100;
    document.getElementById('galleryProgressFill').style.width = progress + '%';
  },

  handleSeek: function (e) {
    var videoEl = document.getElementById('galleryVideoEl');
    if (!videoEl || !videoEl.duration) return;
    var rect = e.currentTarget.getBoundingClientRect();
    var ratio = (e.clientX - rect.left) / rect.width;
    videoEl.currentTime = ratio * videoEl.duration;
    document.getElementById('galleryProgressFill').style.width = (ratio * 100) + '%';
  },

  handleTouchStart: function (e) {
    this.touchStartX = e.touches[0].clientX;
    this.touchEndX = null;
  },

  handleTouchMove: function (e) {
    this.touchEndX = e.touches[0].clientX;
  },

  handleTouchEnd: function () {
    if (this.touchStartX === null || this.touchEndX === null) return;
    var diff = this.touchStartX - this.touchEndX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        this.next();
      } else {
        this.prev();
      }
    }
    this.touchStartX = null;
    this.touchEndX = null;
  }
};